// extracted by mini-css-extract-plugin
export default {"component":"x+Vbe","popover":"+6jcc"};